<template>
  <div
    class="visualization progress-pie-visualization"
    v-loading="loading"
    element-loading-spinner="presupuesto-loader"
  >
    <h3>
      <i class="material-icons">show_chart</i>
      Estado de Avance al {{moment(updatedAt).format('DD-MM-YYYY')}}
    </h3>
    <div class="box">
      <div class="row align-items-center">
        <div class="col-sm-4">
          <div class="period">
            <div class="title">Año</div>
            <div class="year">{{periodo}}</div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="row">
            <div class="col-sm" v-if="showPayments">
              <div class="amount">{{moneyFormatter(get(data, '[0][0].sum'))}}</div>

              <div class="label">Presupuesto Pagado</div>
            </div>
            <div class="col-sm">
              <div class="amount">{{moneyFormatter(get(data, '[1][0].sum'))}}</div>

              <div class="label">Presupuesto Devengado</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
  $red: #ED3232;
.progress-pie-visualization {
    font-family: Roboto;

    h3 {
        font-size: 10px;
        font-weight: 500;
        text-transform: uppercase;
        color: #1b1b1b;
        .material-icons {
            font-size: 10px;
        }
    }
    .box {
        box-shadow: 0 2px 4px 0 rgba(175, 175, 175, 0.5);
        border: 1px solid #f7f7f7;
        border-radius: 4px;
        padding: 18px;
        .period {
          text-align: center;
          padding: 10px 0;
          .title {
            color: $red;
            text-transform: uppercase;
            font-weight: bold;
            line-height: 1;
          }
          .year {
            font-size: 36px;
            font-weight: bold;
            line-height: 1;
          }
        }
        .key {
            height: 16px;
            width: 22px;
            background: black;
            display: inline-block;
        }
        .amount {
            font-size: 18px;
        }
        .percentage {
            color: #009ceb;
            font-weight: 500;
            font-size: 12px;
        }
        .label {
            font-size: 10px;
            text-transform: uppercase;
            font-weight: bold;
            color: #1b1b1b;
        }
    }
}
</style>
<script>
import axios from 'axios';
import PieChart from '../Charts/MultiPie';
import moneyFormatter from '../../Methods/MoneyFormatter';
import _ from 'lodash';
import numeral from 'numeral';
import moment from 'moment';

export default {
    data: function() {
        return {
            updatedAt: this.$store.state.updatedAt,
            periodo: this.$store.state.defaultYear,
            periodos: [],
            loading: false,
            data: [],
            dimensions: { time: ['mes'] },
            mode: 'chart',
            labels: [
                'Presupuesto Pagado',
                'Presupuesto Devengado',
                'Ley vigente mensualizada'
            ]
        };
    },
    props: ['institution', 'showPayments'],
    computed: {
        where: function() {
            let where = {
                periodo: this.periodo,
                partida: this.institution.partida
            };
            if (this.institution.capitulo)
                where.capitulo = this.institution.capitulo;
            if (this.institution.area) where.area = this.institution.area;

            return where;
        },
        url: function() {
            return [
                '/api/v1/data/pagos?metric=monto&group-by=' +
                    JSON.stringify(['periodo']) +
                    '&where=' +
                    JSON.stringify(this.where),
                '/api/v1/data/pagos?metric=devengo&group-by=' +
                    JSON.stringify(['periodo']) +
                    '&where=' +
                    JSON.stringify(this.where)/*,
                '/api/v1/data/aprobados?metric=monto&group-by=' +
                    JSON.stringify(['periodo']) +
                    '&where=' +
                    JSON.stringify(this.where)*/
            ];
        }
    },
    methods: {
        get: _.get,
        numeral: numeral,
        moment: moment,
        moneyFormatter: moneyFormatter,
        refreshData: function() {
            this.loading = true;
            Promise.all([
                axios.get(this.url[0]),
                axios.get(this.url[1]),
                //axios.get(this.url[2])
            ]).then(response => {
                this.loading = false;
                this.data = response.map(d => {
                    return d.data;
                });
            });
        }
    },
    watch: {
        periodo: function(value) {
            this.$store.commit("setDefaultYear", value)
            this.refreshData();
        }
    },
    components: {
        PieChart
    },
    mounted: function() {
        this.refreshData();

        axios
            .get(
                '/api/v1/data/pagos?distinct=' +
                    JSON.stringify(['periodo']) +
                    '&order-by=' +
                    JSON.stringify(['periodo'])
            )
            .then(response => {
                this.periodos = response.data.map(d => {
                    return d.periodo;
                });
            });
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/ProgressPie.vue